import { createFormItem } from "@/component-create/utils/create-form-item"
import { FormDialog } from "@/component-create/FormDialog"
import { FORM_ITEM } from "@/components/form/enums"

import RoleSelect from '@/views/components/RoleSelect.vue'
import DepartmentSelect from '@/views/components/DepartmentSelect.vue'
import { userBaseUrl } from "@/api/system/user"
import { USERNAME } from "@/utils/pattern"

/**
 * 绘制编辑表单
 */
export function renderEditForm(el: Element) {
  const editForm = new FormDialog(
    el,
    {
      items: items,
      elFormProps: { rules: rules },
      saveUrl: userBaseUrl,
      loadUrl: userBaseUrl,
      saveMethods: 'put'
    },
    '编辑'
  )

  return editForm
}

const items = [
  [
    createFormItem('用户名', 'username', FORM_ITEM.INPUT, { clearable: true,disabled:true, maxlength: '100' })
  ],
  [
    createFormItem('昵称', 'nickname', FORM_ITEM.INPUT, { clearable: true, maxlength: '20' }),
    createFormItem('性别', 'gender', FORM_ITEM.SELECT, { loader: 'USER_GENDER' }),
  ],
  [
    createFormItem('手机号码', 'phoneNumber', FORM_ITEM.INPUT, { clearable: true, maxlength: '11' }),
    createFormItem('邮箱地址', 'email', FORM_ITEM.INPUT, { clearable: true, maxlength: '50' }),
  ],
  [
    createFormItem('角色', 'roles', RoleSelect as VueComponent, { multiple: true }),
  ],
  [
    createFormItem('部门', 'departments', DepartmentSelect as VueComponent, { multiple: true }),
  ],
  [
    createFormItem('岗位', 'posts', FORM_ITEM.SELECT, { loader: 'ENABLE_POST',multiple: true  }),
  ],
  [
    createFormItem('状态', 'status', FORM_ITEM.SELECT, { loader: 'USER_STATUS' }),
    null
  ],
  [
    createFormItem('备注', 'remark', FORM_ITEM.INPUT, { type: 'textarea', rows: 3, maxlength: '200', showWordLimit: true }),
  ]
]
const rules = {
  username: [{ required: true, message: '请输入用户名', trigger: 'blur' },
    { min: 4, max: 100, message: '不能少于4个字符,不能超过100个字符', trigger: 'blur' },
    { required: true, message: '只能包含字母、数字、下划线', trigger: 'blur' }],
  nickname: [{ required: true, message: '请输入昵称', trigger: 'blur' },
    { min: 2, max: 20, message: '不能少于2个字符,不能超过100个字符', trigger: 'blur' }],
  gender: [{ required: true, message: '请选择性别', trigger: 'blur' }],
  status: [{ required: true, message: '请选择状态', trigger: 'blur' }]
}
